import { HttpClient } from '@adapters/HttpClient';

// 🎯 Interface para los datos de conexión de WooCommerce
export interface WooCommerceConnectData {
  url: string;
  client_key: string;
  client_secret: string;
}

// 🎯 Interface para la creación de tienda WooCommerce
export interface CreateWooCommerceShopRequest {
  name: string;
  channel_id: number; // 3 para WooCommerce
  connect_data: WooCommerceConnectData;
}

// 🎯 Interface para la respuesta de creación
export interface CreateWooCommerceShopResponse {
  success: boolean;
  message: string;
  shop?: any; // Datos de la tienda creada si es exitoso
}

export class WooCommerceApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /**
   * 🎯 Crear una nueva tienda WooCommerce
   * @param shopData - Datos de la tienda a crear
   * @returns Promise con la respuesta de la API
   */
  async createWooCommerceShop(
    shopData: CreateWooCommerceShopRequest
  ): Promise<CreateWooCommerceShopResponse> {
    try {
      const response =
        await this.httpClient.post<CreateWooCommerceShopResponse>(
          '/shops/create/woocommerce',
          shopData
        );

      return {
        success: true,
        message: response.message || 'Tienda WooCommerce creada exitosamente',
        shop: response.data,
      };
    } catch (error: any) {
      // 🎯 Manejar errores de la API

      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          'Error al crear la tienda WooCommerce',
      };
    }
  }
}
